import React from 'react';

const Halla = ({ width = 1200, height = 1200, color = '#FF952C' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 1200 1200"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g>
                <path
                    fill={color}
                    d="M998.679,570.429c-22.163-60.418-81.739-53.213-91.112-51.666c-25.306-24.451-58.648-43.094-97.697-43.094
                    c-18.145,0-33.689,1.799-46.958,4.684c-8.584-8.634-31.811-26.645-67.216-26.645c-34.288,0-52.543,14.896-59.565,22.702
                    c-18.588-7.326-38.335-11.197-58.443-11.197c-29.25,0-52.492,7.382-70.487,17.219c-4.789-5.986-27.794-30.272-78.542-19.22
                    c-36.014,7.849-49.417,26.506-53.231,33.364c-3.083-0.199-6.193-0.337-9.358-0.337c-43.873,0-75.881,20.36-96.94,40.716
                    c-46.795-4.488-67.226,22.298-73.197,32.437c-35.997,5.01-72.723,40.218-72.723,89.177c0,54.929,33.966,87.723,90.86,87.723H974.77
                    c56.894,0,90.863-32.794,90.863-87.723C1065.633,612.226,1032.727,578.184,998.679,570.429z"
                />
                <g>
                    <path
                        fill="#010101"
                        d="M181.641,604.922c3.859-0.746,7.718-1.492,11.578-2.237c0.953-0.184,1.947-1.05,2.422-1.862
                        c0.509-0.869,0.724-2.149,0.408-3.123c-0.719-2.223-2.751-3.263-4.985-2.83c-3.859,0.746-7.718,1.491-11.577,2.237
                        c-0.953,0.184-1.947,1.05-2.422,1.862c-0.509,0.869-0.724,2.149-0.408,3.123C177.375,604.314,179.406,605.354,181.641,604.922z"
                    />
                    <path
                        fill="#010101"
                        d="M193.807,615.861c0.049,1.111,0.445,2.03,1.187,2.866c2.79,3.138,5.578,6.275,8.367,9.413
                        c0.666,0.749,1.888,1.187,2.865,1.187c0.994,0,2.181-0.441,2.865-1.187c0.71-0.772,1.236-1.787,1.187-2.866
                        c-0.049-1.11-0.445-2.03-1.187-2.865c-2.789-3.138-5.578-6.275-8.367-9.413c-0.666-0.749-1.888-1.187-2.865-1.187
                        c-0.994,0-2.181,0.442-2.866,1.187C194.285,613.768,193.759,614.782,193.807,615.861z"
                    />
                    <path
                        fill="#010101"
                        d="M232.429,599.087c-4.274-2.114-8.996-2.718-13.659-1.673c-2.071,0.464-3.482,2.973-2.83,4.985
                        c0.702,2.173,2.766,3.328,4.985,2.831c0.257-0.058,0.518-0.094,0.777-0.14c1.075-0.107,2.152-0.102,3.228,0.003
                        c1.093,0.191,2.16,0.485,3.193,0.893c0.072,0.034,0.144,0.065,0.216,0.1c0.984,0.487,2.037,0.708,3.123,0.408
                        c0.94-0.259,1.958-0.985,2.422-1.862c0.497-0.941,0.746-2.08,0.408-3.123C233.98,600.544,233.369,599.552,232.429,599.087z"
                    />
                    <path
                        fill="#010101"
                        d="M291.461,551.462c3.661,0.342,7.323,0.684,10.983,1.025c0.977,0.091,2.197-0.518,2.865-1.187
                        c0.703-0.703,1.232-1.856,1.187-2.866c-0.047-1.048-0.391-2.135-1.187-2.866c-0.833-0.765-1.74-1.082-2.865-1.187
                        c-3.661-0.342-7.323-0.684-10.983-1.025c-0.977-0.091-2.197,0.518-2.866,1.187c-0.703,0.703-1.232,1.856-1.187,2.865
                        c0.047,1.048,0.391,2.135,1.187,2.866C289.429,551.04,290.336,551.357,291.461,551.462z"
                    />
                    <path
                        fill="#010101"
                        d="M309.695,528.366c3.658,1.401,7.315,2.802,10.974,4.204c0.926,0.355,2.299,0.073,3.123-0.409
                        c0.841-0.492,1.642-1.456,1.863-2.422c0.236-1.038,0.185-2.202-0.409-3.123c-0.603-0.935-1.385-1.465-2.422-1.862
                        c-3.658-1.401-7.315-2.803-10.974-4.204c-0.926-0.355-2.299-0.073-3.123,0.408c-0.841,0.492-1.642,1.456-1.863,2.422
                        c-0.236,1.038-0.185,2.202,0.409,3.123C307.876,527.438,308.658,527.969,309.695,528.366z"
                    />
                    <path
                        fill="#010101"
                        d="M344.223,540.595c4.745,2.542,9.491,5.084,14.237,7.625c1.867,1.001,4.497,0.53,5.545-1.454
                        c0.995-1.883,0.542-4.476-1.454-5.545c-4.746-2.542-9.491-5.084-14.237-7.626c-1.868-1.001-4.497-0.53-5.545,1.454
                        C341.774,536.932,342.228,539.526,344.223,540.595z"
                    />
                    <path
                        fill="#010101"
                        d="M377.181,522.417c-0.932-0.493-2.09-0.759-3.123-0.408c-0.51,0.173-1.036,0.274-1.565,0.369
                        c-0.505,0.035-1.01,0.035-1.514,0c-0.528-0.096-1.055-0.197-1.564-0.369c-0.962-0.327-2.266-0.093-3.123,0.408
                        c-0.84,0.492-1.642,1.456-1.862,2.422c-0.237,1.038-0.185,2.202,0.408,3.123c0.592,0.917,1.382,1.51,2.422,1.863
                        c1.422,0.482,2.978,0.711,4.476,0.711c1.499,0,3.055-0.228,4.477-0.711c1.002-0.34,1.876-0.931,2.422-1.863
                        c0.509-0.869,0.724-2.149,0.409-3.123C378.727,523.858,378.119,522.912,377.181,522.417z"
                    />
                    <path
                        fill="#010101"
                        d="M519.892,521.592c2.385-0.107,3.817-1.786,4.053-4.053c0.545-5.227,1.089-10.454,1.633-15.681
                        c0.22-2.115-2.021-4.144-4.053-4.053c-2.384,0.107-3.817,1.787-4.053,4.053c-0.544,5.227-1.088,10.454-1.633,15.681
                        C515.619,519.655,517.861,521.683,519.892,521.592z"
                    />
                    <path
                        fill="#010101"
                        d="M549.566,512.387c3.52-2.212,7.041-4.423,10.561-6.635c0.881-0.553,1.583-1.408,1.863-2.422
                        c0.267-0.97,0.146-2.262-0.408-3.123c-1.159-1.796-3.625-2.661-5.546-1.454c-3.52,2.212-7.041,4.423-10.561,6.635
                        c-0.881,0.553-1.583,1.407-1.863,2.422c-0.266,0.97-0.146,2.262,0.409,3.123C545.179,512.73,547.646,513.594,549.566,512.387z"
                    />
                    <path
                        fill="#010101"
                        d="M602.313,497.994c-0.179-0.46-0.363-0.918-0.514-1.389c-0.321-0.997-0.945-1.885-1.863-2.422
                        c-0.869-0.508-2.149-0.724-3.123-0.409c-0.981,0.317-1.927,0.925-2.422,1.862c-0.497,0.942-0.745,2.079-0.408,3.123
                        c1.427,4.436,3.927,8.524,7.342,11.71c0.777,0.725,1.79,1.187,2.866,1.187c0.994,0,2.181-0.442,2.865-1.187
                        c0.709-0.772,1.236-1.786,1.187-2.866c-0.047-1.053-0.395-2.127-1.187-2.866c-0.804-0.75-1.529-1.574-2.222-2.426
                        C603.846,500.963,602.998,499.521,602.313,497.994z"
                    />
                    <path
                        fill="#010101"
                        d="M773.273,521.15c0.605,0.88,1.365,1.572,2.422,1.863c0.97,0.267,2.262,0.146,3.123-0.409
                        c0.865-0.558,1.627-1.388,1.863-2.422c0.232-1.019,0.205-2.23-0.409-3.123c-1.917-2.789-3.834-5.578-5.751-8.367
                        c-0.605-0.88-1.365-1.572-2.422-1.863c-0.97-0.267-2.263-0.146-3.123,0.409c-0.865,0.558-1.627,1.389-1.862,2.422
                        c-0.232,1.019-0.206,2.23,0.408,3.123C769.439,515.571,771.356,518.361,773.273,521.15z"
                    />
                    <path
                        fill="#010101"
                        d="M803.397,518.967c1.004-0.045,2.21-0.365,2.865-1.187c2.09-2.617,4.179-5.233,6.268-7.85
                        c0.396-0.367,0.675-0.802,0.838-1.304c0.253-0.483,0.37-1.004,0.349-1.562c0-0.994-0.442-2.181-1.187-2.866
                        c-0.772-0.709-1.786-1.236-2.865-1.187c-1.004,0.045-2.21,0.365-2.866,1.187c-2.089,2.617-4.178,5.233-6.267,7.85
                        c-0.396,0.367-0.675,0.802-0.838,1.304c-0.254,0.483-0.37,1.004-0.349,1.562c0,0.994,0.442,2.181,1.187,2.866
                        C801.303,518.489,802.318,519.016,803.397,518.967z"
                    />
                    <path
                        fill="#010101"
                        d="M861.992,518.513c-3.495-0.649-6.99-1.299-10.485-1.948c-1.089-0.202-2.138-0.168-3.123,0.409
                        c-0.84,0.492-1.642,1.456-1.863,2.422c-0.236,1.037-0.185,2.202,0.409,3.123c0.544,0.844,1.396,1.672,2.422,1.862
                        c3.495,0.649,6.99,1.299,10.485,1.948c1.089,0.203,2.138,0.168,3.123-0.408c0.84-0.492,1.642-1.456,1.862-2.422
                        c0.237-1.038,0.185-2.202-0.408-3.123C863.87,519.531,863.018,518.704,861.992,518.513z"
                    />
                    <path
                        fill="#010101"
                        d="M883.449,540.291c-0.995-0.227-2.267-0.23-3.123,0.409c-2.991,2.229-5.982,4.458-8.972,6.688
                        c-0.877,0.654-1.561,1.326-1.863,2.422c-0.266,0.97-0.146,2.262,0.409,3.123c0.558,0.865,1.389,1.627,2.422,1.863
                        c0.994,0.226,2.266,0.23,3.123-0.409c2.991-2.229,5.982-4.458,8.972-6.688c0.877-0.654,1.561-1.326,1.862-2.422
                        c0.267-0.97,0.146-2.262-0.408-3.123C885.313,541.288,884.482,540.526,883.449,540.291z"
                    />
                    <path
                        fill="#010101"
                        d="M683.472,488.987c1.46,1.543,4.279,1.582,5.732,0c1.518-1.654,1.558-4.085,0-5.732
                        c-2.967-3.135-5.934-6.269-8.9-9.403c-1.46-1.543-4.278-1.583-5.732,0c-1.518,1.655-1.558,4.085,0,5.732
                        C677.54,482.718,680.506,485.853,683.472,488.987z"
                    />
                    <path
                        fill="#010101"
                        d="M707.143,482.328c2.964-1.567,5.929-3.134,8.893-4.701c0.877-0.464,1.604-1.482,1.863-2.422
                        c0.267-0.97,0.146-2.262-0.408-3.123c-1.231-1.909-3.538-2.516-5.545-1.454c-2.964,1.567-5.929,3.134-8.893,4.701
                        c-0.877,0.464-1.604,1.482-1.862,2.422c-0.267,0.97-0.146,2.262,0.408,3.123C702.829,482.783,705.136,483.39,707.143,482.328z"
                    />
                    <path
                        fill="#010101"
                        d="M416.601,491.076c3.288,2.128,6.577,4.257,9.865,6.385c1.783,1.154,4.554,0.421,5.545-1.454
                        c1.065-2.016,0.449-4.313-1.454-5.545c-3.288-2.129-6.577-4.257-9.865-6.386c-1.783-1.154-4.554-0.421-5.545,1.454
                        C414.082,487.548,414.698,489.844,416.601,491.076z"
                    />
                    <path
                        fill="#010101"
                        d="M456.191,497.547c1.033-0.046,2.161-0.381,2.866-1.187c2.44-2.789,4.881-5.578,7.321-8.367
                        c0.714-0.816,1.187-1.754,1.187-2.865c0-0.994-0.441-2.181-1.187-2.866c-0.773-0.709-1.787-1.235-2.866-1.187
                        c-1.033,0.046-2.161,0.381-2.866,1.187c-2.44,2.789-4.881,5.578-7.321,8.367c-0.714,0.816-1.187,1.754-1.187,2.865
                        c0,0.994,0.442,2.181,1.187,2.866C454.098,497.069,455.112,497.595,456.191,497.547z"
                    />
                    <path
                        fill="#010101"
                        d="M973.693,595.342c-1.429,1.557-1.673,4.206,0,5.732c4.193,3.825,8.386,7.65,12.578,11.474
                        c1.566,1.429,4.204,1.664,5.732,0c1.429-1.557,1.673-4.205,0-5.732c-4.193-3.825-8.385-7.649-12.578-11.474
                        C977.858,593.913,975.22,593.679,973.693,595.342z"
                    />
                    <path
                        fill="#010101"
                        d="M1003.907,612.247c0.174,0.949,1.058,1.951,1.863,2.422c0.869,0.508,2.149,0.724,3.123,0.408
                        c0.981-0.317,1.927-0.925,2.422-1.862c0.534-1.011,0.615-1.998,0.408-3.123c-0.617-3.363-1.234-6.727-1.851-10.09
                        c-0.174-0.949-1.058-1.951-1.863-2.422c-0.868-0.508-2.149-0.724-3.123-0.409c-0.98,0.317-1.927,0.925-2.422,1.862
                        c-0.534,1.011-0.615,1.998-0.408,3.123C1002.673,605.52,1003.29,608.883,1003.907,612.247z"
                    />
                    <path
                        fill="#010101"
                        d="M1025.894,623.839c1.501,1.289,3.003,2.578,4.504,3.867c0.367,0.395,0.802,0.674,1.305,0.838
                        c0.483,0.254,1.003,0.37,1.561,0.349c0.558,0.021,1.078-0.095,1.561-0.349c0.503-0.163,0.937-0.443,1.304-0.838
                        c0.709-0.772,1.235-1.786,1.187-2.866c-0.048-0.359-0.097-0.718-0.144-1.077c-0.193-0.687-0.54-1.283-1.043-1.788
                        c-1.501-1.289-3.003-2.578-4.505-3.867c-0.367-0.395-0.802-0.674-1.304-0.838c-0.483-0.254-1.003-0.37-1.561-0.349
                        c-0.558-0.021-1.078,0.095-1.561,0.349c-0.503,0.164-0.937,0.443-1.304,0.838c-0.71,0.772-1.236,1.787-1.187,2.866
                        c0.048,0.359,0.096,0.718,0.144,1.078C1025.044,622.737,1025.392,623.334,1025.894,623.839z"
                    />
                    <path
                        fill="#010101"
                        d="M944.094,548.855c5.458,2.715,11.192,4.884,17.106,6.371c2.053,0.516,4.492-0.664,4.985-2.83
                        c0.479-2.102-0.631-4.433-2.83-4.986c-2.74-0.689-5.441-1.514-8.093-2.488c-0.65-0.239-1.298-0.487-1.943-0.743
                        c-0.323-0.128-0.643-0.261-0.964-0.391c-0.023-0.01-0.03-0.012-0.049-0.02c-0.071-0.031-0.143-0.061-0.214-0.092
                        c-1.319-0.571-2.62-1.179-3.906-1.819c-1.896-0.943-4.476-0.57-5.545,1.454C941.671,545.144,942.067,547.847,944.094,548.855z"
                    />
                    <path
                        fill="#010101"
                        d="M223.975,561.281c2.79,0.929,5.579,1.859,8.367,2.789c0.966,0.322,2.262,0.095,3.123-0.409
                        c0.84-0.492,1.642-1.456,1.862-2.422c0.236-1.037,0.185-2.202-0.408-3.123c-0.59-0.915-1.383-1.516-2.422-1.862
                        c-2.789-0.93-5.578-1.859-8.367-2.789c-0.966-0.322-2.262-0.096-3.123,0.408c-0.841,0.492-1.642,1.456-1.863,2.422
                        c-0.236,1.038-0.185,2.202,0.409,3.123C222.142,560.333,222.935,560.934,223.975,561.281z"
                    />

                    <path
                        fill="#010101"
                        d="M204.657,576.859c10.404,0,21.187,1.393,31.414,4.48c0.416,0.412,0.917,0.748,1.507,0.953
                        c0.441,0.153,0.892,0.224,1.332,0.224c0.187,0,0.363-0.059,0.546-0.084c23.812,8.185,43.932,26.046,47.99,57.826
                        c0.261,2.045,2.005,3.538,4.016,3.538c0.172,0,0.346-0.011,0.52-0.032c2.219-0.285,3.789-2.314,3.507-4.536
                        c-4.404-34.484-25.549-54.224-50.836-63.611c3.325-6.496,11.639-20.077,29.717-37.083c1.631-1.533,1.71-4.1,0.177-5.728
                        c-1.533-1.633-4.103-1.71-5.728-0.177c-19.832,18.654-28.615,33.602-31.964,40.453c-10.542-2.973-21.551-4.329-32.197-4.329
                        c-2.237,0-4.053,1.815-4.053,4.053C200.604,575.044,202.42,576.859,204.657,576.859z"
                    />
                    <path
                        fill="#010101"
                        d="M366.071,504.345c34.377,0,63.727,12.699,86.752,31.227c0.156,0.154,0.327,0.293,0.511,0.423
                        c32.561,26.435,52.338,64.533,55.479,94.754c0.216,2.084,1.976,3.633,4.026,3.633c0.14,0,0.282-0.008,0.425-0.021
                        c2.227-0.232,3.842-2.224,3.612-4.451c-3.235-31.122-23.134-70.144-55.941-97.983c4.99-7.675,20.315-29.306,42.318-42.55
                        c1.918-1.153,2.536-3.644,1.383-5.562c-1.156-1.921-3.646-2.536-5.562-1.383c-23.028,13.858-38.747,35.581-44.499,44.379
                        c-23.835-18.247-53.73-30.571-88.503-30.571c-2.237,0-4.053,1.815-4.053,4.053S363.834,504.345,366.071,504.345z"
                    />
                    <path
                        fill="#010101"
                        d="M577.689,473.318c86.884,0,147.987,74.636,153.546,128.145c0.216,2.084,1.976,3.633,4.026,3.633
                        c0.14,0,0.282-0.008,0.425-0.021c2.224-0.232,3.842-2.224,3.612-4.451c-3.026-29.129-21.362-63.05-47.852-88.525
                        c-31.441-30.235-71.842-46.887-113.757-46.887c-2.237,0-4.053,1.815-4.053,4.053C573.636,471.503,575.451,473.318,577.689,473.318
                        z"
                    />
                    <path
                        fill="#010101"
                        d="M809.871,483.775c50.174,0,86.295,32.929,103.361,52.557c25.609,29.456,39.011,62.57,39.011,80.053
                        c0,2.237,1.815,4.053,4.053,4.053c2.237,0,4.053-1.815,4.053-4.053c0-9.132-3.061-21.289-8.799-34.631
                        c10.067-3.192,21.309-4.894,32.635-4.894c2.237,0,4.053-1.815,4.053-4.053c0-2.237-1.815-4.053-4.053-4.053
                        c-12.509,0-24.962,1.931-36.061,5.577c-21.894-44.744-71.832-98.661-138.253-98.661c-2.237,0-4.053,1.815-4.053,4.053
                        C805.818,481.96,807.633,483.775,809.871,483.775z"
                    />
                </g>
            </g>
        </svg>
    );
};

export default Halla;
